import unescape from 'lodash-es/unescape'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { getProductLink } from '@utils/routing/getProductLink'

import type { Product } from '../../types'
import * as S from './EmbeddedProductsTooltip.styled'

export type EmbeddedProductsTooltipProps = {
  embeddedOffers: NonNullable<Product['embeddedOffers']>
}

export const EmbeddedProductsTooltip = ({ embeddedOffers }: EmbeddedProductsTooltipProps) => {
  const navigate = useNavigate()

  if (!embeddedOffers || embeddedOffers.length === 0) {
    return null
  }

  const handleProductClick = (offerId: string) => {
    const link = getProductLink('STANDARD', offerId)
    navigate(link)
  }

  return (
    <S.TooltipContainer>
      <S.ScrollableContent>
        {embeddedOffers.map((offer) => (
          <S.ProductItem key={offer.id} onClick={() => handleProductClick(offer.id)}>
            <S.Thumbnail>
              {offer.thumbnail ? (
                <img src={offer.thumbnail} alt={offer.name} />
              ) : (
                <div style={{ fontSize: '24px', color: '#999' }}>📦</div>
              )}
            </S.Thumbnail>
            <S.ProductName>{unescape(offer.name)}</S.ProductName>
          </S.ProductItem>
        ))}
      </S.ScrollableContent>
    </S.TooltipContainer>
  )
}
